import React from 'react'
import { Link as ReactLink } from "react-router-dom";
import { Button } from "@chakra-ui/react";

export const NavButton = (props) => {
    const { title, path, color } = props;

    return (
        <Button
            as={ReactLink}
            fontWeight={400}
            size="lg"
            variant="tertiary"
            color={color}
            _hover={{backgroundColor: 'white', textColor: 'black'}}
            justifyContent="start"
            to={path}
            lineHeight={1}
            p={{
                base: 4,
                md: 3,
            }}
            style={{
                height: 'auto',
            }}
        >
            {title}
        </Button>
    )
};
